import Cookies from 'js-cookie';

class CustomAuthStorage {
  constructor(data) {
    this.domain = data.domain;
    this.sameSite = data.sameSite;
    this.path = data.path || '/';
    
    if (Object.prototype.hasOwnProperty.call(data, 'expires')) {
      this.expires = data.expires;
    }
    
    if (Object.prototype.hasOwnProperty.call(data, 'secure')) {
      this.secure = data.secure;
    } else {
      this.secure = true;
    }
  }

  // Required methods for KeyValueStorageInterface
  setItem(key, value) {
    Cookies.set(key, value, {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure,
      sameSite: this.sameSite,
    });
    return Promise.resolve();
  }

  getItem(key) {
    const value = Cookies.get(key);
    return Promise.resolve(value);
  }

  removeItem(key) {
    Cookies.remove(key, {
      path: this.path,
      domain: this.domain,
      secure: this.secure,
      sameSite: this.sameSite
    });
    return Promise.resolve();
  }

  // New required methods for Amplify v6
  async sync() {
    return Promise.resolve();
  }
  
  async clear() {
    const cookies = Cookies.get();
    for (const key in cookies) {
      Cookies.remove(key, {
        path: this.path,
        domain: this.domain,
        secure: this.secure,
        sameSite: this.sameSite
      });
    }
    return Promise.resolve();
  }
}

export default CustomAuthStorage;